import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GenericEntitySearchType } from './generic-entity-search-type';
import { Observable } from 'rxjs';
import { GenericEntitySearch, LookupResponse } from './generic-entity-search-model';
import { ApiUrls } from '../../utility/apiurls-shared';

@Injectable({
  providedIn: 'root',
})
export class GenericEntitySearchService {
  private httpClient = inject(HttpClient);
  private apiUrls = inject(ApiUrls);

  
 

  

  search(
    searchType: GenericEntitySearchType,
    searchValues: GenericEntitySearch,
  ): Observable<LookupResponse> {
    const lookupUrl: string = this.getLookupUrl(searchType);

    return this.httpClient.post<LookupResponse>(lookupUrl, searchValues);
  }

  private getLookupUrl(searchType: GenericEntitySearchType): string {
    // We are currently not using search types, consider removing this component
    switch (searchType) {
      case GenericEntitySearchType.Employer:
        return null; // this.apiUrls.employer.lookup();
      case GenericEntitySearchType.Insurer:
        return null; // this.apiUrls.insurer.lookup();
      default:
        throw new Error(`Could not find lookup URL for search type ${searchType}`);
    }
  }
}
